<!-- <button class="btn btn-primary m-4" (click)="openCyclinderDashboard()">Open dd</button> -->
<mat-toolbar class="top_headerbar">
  <div class="left">
    <select class="custom_select form-control width_180" (change)="onSiteSelected($event.target.value)">
      <option value="0">All Sites</option>
      <option value="{{ site.site_id }}" *ngFor="let site of sites">
        {{ site.site_name }}
      </option>
    </select>
    <select class="custom_select form-control width_180" (change)="onAppSelected($event.target.value)">
      <option value="0">All Applications</option>
      <option value="{{ app.app_id }}" *ngFor="let app of filteredApplications">
        {{ app.app_name }}
      </option>
    </select>
  </div>
</mat-toolbar>
<div class="cyclinders-container">
  <div class="grid-container">
    <!-- Using *ngFor to loop through cylinder data -->
    <div class="card" *ngFor="let cylinder of filteredCylinders"
      [class.out-for-service]="cylinder.status === 'out-for-service'" (click)="openCyclinderDashboard(cylinder)">
      <div class="card-header">
        <div class="card-title">{{ cylinder.device_sno }}</div>
        <span class="status-indicator" [ngClass]="getStatusClass(cylinder.status)"></span>
      </div>
      <div class="card-body">
        <div class="asset-id">{{ cylinder.name }}</div>
        <div class="asset-image">
          <!-- Using the cylinder image from your assets folder -->
          <img src="assets/cylinder-horizontal.png" alt="Cylinder" class="cylinder-image" />
        </div>
      </div>
      <div class="card-footer">
        <span class="driven-tag">{{
          cylinder.equipmentType || "Driven Equipment"
          }}</span>
        <div *ngIf="cylinder.status === 'out-for-service'">Out for service</div>
      </div>
    </div>
    @if (!filteredCylinders || filteredCylinders.length == 0) {
    <div class="cylinder-card-skeleton">
      <div class="cylinder-card-skeleton__status"></div>
      <div class="cylinder-card-skeleton__id"></div>
      <div class="cylinder-card-skeleton__name"></div>
      <div class="cylinder-card-skeleton__icon-container">
        <div class="icon-skeleton"></div>
      </div>
      <div class="cylinder-card-skeleton__footer"></div>
    </div>
    }
  </div>
</div>